export class InogeniUsbToggle {
    constructor(socket) {
        this.socket = socket;
        this.firmwareVersion = '1.00';
        this.usbHost = '1';
        this.asyncHandlers = [
            {
                name: 'autoSwitch',
                regExp: /SM (.+)/i,
                callback: (match) => {
                    this.socket.send('ACK');
                },
            },
            {
                name: 'firmwareVersion',
                regExp: /FW/i,
                callback: (match) => {
                    this.socket.send(`FW.VER:${this.firmwareVersion}`);
                },
            },
            {
                name: 'videoMatrixRoutesQuery',
                regExp: /GH/i,
                callback: (match) => {
                    this.socket.send(`${this.usbHost}`);
                },
            },
            {
                name: 'videoMatrixRoutesSet',
                regExp: /SH (.+)/i,
                callback: (match) => {
                    this.usbHost = match[1];
                    this.socket.send(`ACK`);
                },
            },
        ];
    }
}
InogeniUsbToggle.emulatorType = 'socketEmulator';
InogeniUsbToggle.key = '-N0H1g5nsgK8p4kxwSev';
